/**
 * Get a display name for a component
 * @param {Object} Component - a React component
 * @returns {string} - the component name
 */
export default function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component'
}
